import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import path from '../../../helpers/path';
import SVG from 'react-inlinesvg';
import config from '../../../config';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import './APLogo.css';
var APLogo = function APLogo(props) {
  var customClass = props.customClass,
    linkTo = props.linkTo,
    onClick = props.onClick;
  var bemClasses = getBEMClasses('ap-logo', customClass);
  var renderSiteLogo = function renderSiteLogo() {
    if (config.global.siteLogo.match(/.svg$/) && !config.Logo.DoNotInLineSVG) {
      return React.createElement(SVG, {
        alt: 'Site logo',
        src: path('/local/logos/' + config.global.siteLogo),
        className: bemClasses('img')
      });
    } else {
      return React.createElement('img', {
        alt: 'Site logo',
        src: path('/local/logos/' + config.global.siteLogo),
        className: bemClasses('img')
      });
    }
  };
  return React.createElement('div', {
    className: bemClasses()
  }, linkTo ? React.createElement(Link, {
    className: bemClasses('link'),
    to: path(linkTo),
    onClick: onClick
  }, renderSiteLogo()) : renderSiteLogo());
};
APLogo.defaultProps = {
  customClass: '',
  linkTo: ''
};
APLogo.propTypes = {
  customClass: PropTypes.string,
  linkTo: PropTypes.string,
  onClick: PropTypes.func
};
export default APLogo;